import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}xml/ski/restech/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getXmlChannels() {
    return conduit.get('xml-channels');
  },

  /**
   * @returns {AxiosPromise}
   */
  getXmlChannelAddons(xmlChannelId) {
    return conduit.get(`addons/by-xml-channel-id/${xmlChannelId}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  updateAddon(addon) {
    return conduit.put(
      `addons/${addon.id}/update`,
      addon,
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/restech-service.js